/* eslint-disable new-cap */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import copy from 'copy-to-clipboard';
import QRCode from 'qrcode.react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import Certifield from '../../../assets/post.png';
import './certificado.scss';
import { notify } from '../../../functions/notifications';

function ModalCertificado({ elemento: { props: { clienteUid, userUid } } }) {
  function printDocument() {
    const input = document.getElementById('divToPrint');
    const imgPrint = document.getElementById('imagToPrint');
    const qrCodeToPrint = document.getElementById('modal-qr-code');
    const qrcodeGeradoToPrint = document.getElementById('qrcode-gerado');

    if (window.screen.width < 1000) {
      imgPrint.style.width = '230px';
      imgPrint.style.height = '370px';
      qrCodeToPrint.style.top = '50px';
      qrCodeToPrint.style.left = '75px';
      qrCodeToPrint.style.width = '80px';
      qrCodeToPrint.style.height = '80px';
    } else {
      imgPrint.style.width = '550px';
      imgPrint.style.height = '900px';
      qrCodeToPrint.style.top = '100px';
      qrCodeToPrint.style.left = '0px';
      qrCodeToPrint.style.width = '170px';
      qrCodeToPrint.style.height = '170px';
      qrcodeGeradoToPrint.style.width = '155px';
      qrcodeGeradoToPrint.style.height = '155px';
    }

    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/pdf');
        const pdf = new jsPDF();
        pdf.addImage(imgData, 'JPEG', 0, 0);
        pdf.save('download.pdf');

        if (window.screen.width < 1000) {
          imgPrint.style.width = '290px';
          imgPrint.style.height = '470px';
          qrCodeToPrint.style.top = '53px';
          qrCodeToPrint.style.left = '45px';
          qrCodeToPrint.style.width = '90px';
          qrCodeToPrint.style.height = '90px';
        } else {
          imgPrint.style.width = '230px';
          imgPrint.style.height = '370px';
          qrCodeToPrint.style.top = '50px';
          qrCodeToPrint.style.left = '145px';
          qrCodeToPrint.style.width = '75px';
          qrCodeToPrint.style.height = '75px';
          qrcodeGeradoToPrint.style.width = '60px';
          qrcodeGeradoToPrint.style.height = '60px';
        }
      });
  }

  return (
    <div id="modal-certificado-exibir">
      <div id="divToPrint" className="modal-post">
        <div id="modal-qr-code" className="modal-qr-code">
          <QRCode
            value={`https://agsafe.netlify.app/authentication/${clienteUid}/key=${userUid}`}
            level="L"
            size="200"
            fgColor="#000000"
            bgColor="#FFFFFF"
            renderAs="svg"
            className="qrcode-gerado"
            id="qrcode-gerado"
          />
        </div>
        <img id="imagToPrint" src={Certifield} alt="Certifield" />
      </div>
      <div className="modal-copy-certifield">
        <span>
          {`${String(`https://agsafe.netlify.app/authentication/${clienteUid}/key=${userUid}`).substring(0, 40)}...`}
        </span>
        <button
          className="buttons-transparent"
          type="button"
          onClick={() => {
            notify('success', 'Link copiado');
            copy(`https://agsafe.netlify.app/authentication/${clienteUid}/key=${userUid}`);
          }}
        >
          <i className="far fa-clone" />
        </button>
      </div>
      <button className="buttons-transparent" type="button" onClick={printDocument}>
        <i className="fas fa-download">
          <span>
            Baixar Certificado
          </span>
        </i>
      </button>
    </div>
  );
}

export default ModalCertificado;
